import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { WhoIsItFor } from './components/WhoIsItFor';
import { SystemFeatures } from './components/SystemFeatures';
import { TomosAccordion } from './components/TomosAccordion';
import { Bonuses } from './components/Bonuses';
import { CostComparison } from './components/CostComparison';
import { Pricing } from './components/Pricing';
import { MasterKitExplanation } from './components/MasterKitExplanation';
import { MasterKitIncludes } from './components/MasterKitIncludes';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-gray-900 selection:bg-brand-orange/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <WhoIsItFor data-id="element-4" />
      <SystemFeatures data-id="element-5" />
      <TomosAccordion data-id="element-6" />
      <Bonuses data-id="element-7" />
      <CostComparison data-id="element-8" />
      <Pricing data-id="element-9" />
      <MasterKitExplanation data-id="element-10" />
      <MasterKitIncludes data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}